import DownloadModal from './DownloadModal';

export default DownloadModal;
